import {
  Avatar,
  Button,
  Card,
  Dialog,
  FormControl,
  Grid,
  IconButton,
  MenuItem,
  Select,
  Stack,
  Switch,
  Typography,
  Box,
  useMediaQuery,
} from '@mui/material';
import { useTheme } from '@emotion/react';
import { useState, useEffect } from 'react';
import { poppins500 } from 'theme/common.style';
import { getApiCall } from 'api/apiService';
import { OWNERCARD_EXPANDEDCENTER } from 'constant/app.config';
import PlaceholderImage from 'assets/svg/Placeholder.svg';
import Loading from 'assets/images/loading.png';
import moment from 'moment';

export const BedIcon = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_12294_29983)">
        <path
          d="M2.10938 8.89211H14.6197C15.1354 8.89211 15.5533 8.47413 15.5533 7.95851C15.5533 7.44288 15.1354 7.0249 14.6197 7.0249H2.10938C1.59376 7.0249 1.17578 7.44288 1.17578 7.95851C1.17575 8.47413 1.59376 8.89211 2.10938 8.89211Z"
          fill="#6C2AD2"
        />
        <path
          d="M9.29884 5.01123C9.02635 5.01123 8.80469 5.23289 8.80469 5.50538V6.14602H12.6291V5.50538C12.6291 5.23289 12.4074 5.01123 12.1349 5.01123H9.29884Z"
          fill="#6C2AD2"
        />
        <path
          d="M3.21938 5.50547C3.21938 4.74835 3.83531 4.13241 4.59243 4.13241H7.42852C7.78881 4.13241 8.11693 4.2721 8.36212 4.49991C8.6073 4.2721 8.93543 4.13241 9.29572 4.13241H12.1318C12.8889 4.13241 13.5049 4.74835 13.5049 5.50547V6.1461H14.9313V3.11915C14.9313 2.60353 14.5133 2.18555 13.9977 2.18555H2.72657C2.21095 2.18555 1.79297 2.60353 1.79297 3.11915V6.1461H3.21938V5.50547Z"
          fill="#6C2AD2"
        />
        <path
          d="M4.59181 5.01123C4.31932 5.01123 4.09766 5.23289 4.09766 5.50538V6.14602H7.92204V5.50538C7.92204 5.23289 7.70038 5.01123 7.42789 5.01123H4.59181Z"
          fill="#6C2AD2"
        />
        <path
          d="M0.863281 9.77124V13.8147H1.74219V12.2123H14.9844V13.8147H15.8633V9.77124H0.863281Z"
          fill="#6C2AD2"
        />
      </g>
      <defs>
        <clipPath id="clip0_12294_29983">
          <rect
            width="15"
            height="15"
            fill="white"
            transform="translate(0.863281 0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
export const ShowerIcon = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_12294_29992)">
        <path
          d="M13.4883 0.5C13.0741 0.5 12.7383 0.835781 12.7383 1.25V1.5H7.23828C6.54828 1.50081 5.98909 2.06 5.98828 2.75V4H5.48828C5.07406 4 4.73828 4.33578 4.73828 4.75V5.61125C3.64931 6.28247 2.98678 7.47078 2.98828 8.75V9.046C2.68969 9.15156 2.48959 9.43331 2.48828 9.75V10.25C2.48828 10.3881 2.60022 10.5 2.73828 10.5H10.7383C10.8763 10.5 10.9883 10.3881 10.9883 10.25V9.75C10.987 9.43331 10.7869 9.15156 10.4883 9.046V8.75C10.4897 7.7545 10.0938 6.79959 9.38828 6.09725C9.19222 5.90819 8.97394 5.74356 8.73828 5.607V4.75C8.73828 4.33578 8.4025 4 7.98828 4H7.48828V3.25C7.48828 3.11194 7.60022 3 7.73828 3H12.7383V3.5C12.7383 3.91422 13.0741 4.25 13.4883 4.25H14.2383V0.5H13.4883ZM10.4883 9.75V10H2.98828V9.75C2.98828 9.61194 3.10022 9.5 3.23828 9.5H10.2383C10.3763 9.5 10.4883 9.61194 10.4883 9.75ZM9.03603 6.4515C9.64697 7.06022 9.98972 7.88756 9.98828 8.75V9H3.48828V8.75C3.48747 7.62038 4.08391 6.5745 5.05653 6H8.42178C8.64541 6.12297 8.85194 6.27475 9.03603 6.4515ZM7.98828 4.5C8.12634 4.5 8.23828 4.61194 8.23828 4.75V5.5H5.23828V4.75C5.23828 4.61194 5.35022 4.5 5.48828 4.5H7.98828ZM12.7383 2.5H7.73828C7.32406 2.5 6.98828 2.83578 6.98828 3.25V4H6.48828V2.75C6.48828 2.33578 6.82406 2 7.23828 2H12.7383V2.5ZM13.7383 3.75H13.4883C13.3502 3.75 13.2383 3.63806 13.2383 3.5V1.25C13.2383 1.11194 13.3502 1 13.4883 1H13.7383V3.75Z"
          fill="#6C2AD2"
        />
        <path
          d="M6.73828 11C6.60022 11 6.48828 11.1119 6.48828 11.25V12.25C6.48828 12.3881 6.60022 12.5 6.73828 12.5C6.87634 12.5 6.98828 12.3881 6.98828 12.25V11.25C6.98828 11.1119 6.87634 11 6.73828 11Z"
          fill="#6C2AD2"
        />
        <path
          d="M6.73828 13C6.60022 13 6.48828 13.1119 6.48828 13.25V14.25C6.48828 14.3881 6.60022 14.5 6.73828 14.5C6.87634 14.5 6.98828 14.3881 6.98828 14.25V13.25C6.98828 13.1119 6.87634 13 6.73828 13Z"
          fill="#6C2AD2"
        />
        <path
          d="M9.73828 12C9.60022 12 9.48828 12.1119 9.48828 12.25V13.25C9.48828 13.3881 9.60022 13.5 9.73828 13.5C9.87634 13.5 9.98828 13.3881 9.98828 13.25V12.25C9.98828 12.1119 9.87634 12 9.73828 12Z"
          fill="#6C2AD2"
        />
        <path
          d="M7.73828 12C7.60022 12 7.48828 12.1119 7.48828 12.25V13.25C7.48828 13.3881 7.60022 13.5 7.73828 13.5C7.87634 13.5 7.98828 13.3881 7.98828 13.25V12.25C7.98828 12.1119 7.87634 12 7.73828 12Z"
          fill="#6C2AD2"
        />
        <path
          d="M5.73828 12C5.60022 12 5.48828 12.1119 5.48828 12.25V13.25C5.48828 13.3881 5.60022 13.5 5.73828 13.5C5.87634 13.5 5.98828 13.3881 5.98828 13.25V12.25C5.98828 12.1119 5.87634 12 5.73828 12Z"
          fill="#6C2AD2"
        />
        <path
          d="M3.73828 12C3.60022 12 3.48828 12.1119 3.48828 12.25V13.25C3.48828 13.3881 3.60022 13.5 3.73828 13.5C3.87634 13.5 3.98828 13.3881 3.98828 13.25V12.25C3.98828 12.1119 3.87634 12 3.73828 12Z"
          fill="#6C2AD2"
        />
        <path
          d="M4.73828 11C4.60022 11 4.48828 11.1119 4.48828 11.25V12.25C4.48828 12.3881 4.60022 12.5 4.73828 12.5C4.87634 12.5 4.98828 12.3881 4.98828 12.25V11.25C4.98828 11.1119 4.87634 11 4.73828 11Z"
          fill="#6C2AD2"
        />
        <path
          d="M8.73828 11C8.60022 11 8.48828 11.1119 8.48828 11.25V12.25C8.48828 12.3881 8.60022 12.5 8.73828 12.5C8.87634 12.5 8.98828 12.3881 8.98828 12.25V11.25C8.98828 11.1119 8.87634 11 8.73828 11Z"
          fill="#6C2AD2"
        />
        <path
          d="M8.73828 13C8.60022 13 8.48828 13.1119 8.48828 13.25V14.25C8.48828 14.3881 8.60022 14.5 8.73828 14.5C8.87634 14.5 8.98828 14.3881 8.98828 14.25V13.25C8.98828 13.1119 8.87634 13 8.73828 13Z"
          fill="#6C2AD2"
        />
        <path
          d="M4.73828 13C4.60022 13 4.48828 13.1119 4.48828 13.25V14.25C4.48828 14.3881 4.60022 14.5 4.73828 14.5C4.87634 14.5 4.98828 14.3881 4.98828 14.25V13.25C4.98828 13.1119 4.87634 13 4.73828 13Z"
          fill="#6C2AD2"
        />
        <path
          d="M5.73828 14C5.60022 14 5.48828 14.1119 5.48828 14.25V15.25C5.48828 15.3881 5.60022 15.5 5.73828 15.5C5.87634 15.5 5.98828 15.3881 5.98828 15.25V14.25C5.98828 14.1119 5.87634 14 5.73828 14Z"
          fill="#6C2AD2"
        />
        <path
          d="M7.73828 14C7.60022 14 7.48828 14.1119 7.48828 14.25V15.25C7.48828 15.3881 7.60022 15.5 7.73828 15.5C7.87634 15.5 7.98828 15.3881 7.98828 15.25V14.25C7.98828 14.1119 7.87634 14 7.73828 14Z"
          fill="#6C2AD2"
        />
      </g>
      <defs>
        <clipPath id="clip0_12294_29992">
          <rect
            width="15"
            height="15"
            fill="white"
            transform="translate(0.863281 0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
export const CarIcon = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_12294_30034)">
        <path
          d="M11.5005 6.99815C11.4523 6.99815 11.4027 7.00509 11.3532 7.01868L10.7933 7.17291L10.212 5.7567C10.0473 5.3555 9.56046 5.02905 9.12679 5.02905H3.68596C3.25224 5.02905 2.76545 5.3555 2.60077 5.7567L2.02019 7.17093L1.46725 7.01863C1.41777 7.00503 1.36823 6.9981 1.31996 6.9981C1.05532 6.9981 0.863281 7.20026 0.863281 7.47872V7.80874C0.863281 8.13382 1.12781 8.39835 1.45288 8.39835H1.51624L1.42239 8.62693C1.26938 8.99956 1.14482 9.63066 1.14482 10.0337V12.8471C1.14482 13.1722 1.40935 13.4367 1.73442 13.4367H2.50445C2.82952 13.4367 3.09405 13.1722 3.09405 12.8471V12.1446H9.71864V12.8471C9.71864 13.1722 9.98317 13.4367 10.3082 13.4367H11.0782C11.4032 13.4367 11.6678 13.1722 11.6678 12.8471V10.0337C11.6678 9.63077 11.5432 8.99967 11.3902 8.62699L11.2963 8.3984H11.3676C11.6926 8.3984 11.9572 8.13387 11.9572 7.8088V7.47877C11.9572 7.20032 11.7651 6.99815 11.5005 6.99815ZM2.44285 8.07817L3.3223 5.93608C3.42083 5.6961 3.71365 5.49971 3.97306 5.49971H8.83969C9.0991 5.49971 9.39192 5.69604 9.49044 5.93608L10.3699 8.07817C10.4684 8.31815 10.3368 8.51454 10.0773 8.51454H2.73545C2.47599 8.51448 2.34439 8.31815 2.44285 8.07817ZM4.40601 10.7877C4.40601 10.9174 4.29984 11.0235 4.17021 11.0235H2.4996C2.36987 11.0235 2.26375 10.9174 2.26375 10.7877V9.98596C2.26375 9.85628 2.36987 9.75016 2.4996 9.75016H4.17021C4.29984 9.75016 4.40601 9.85628 4.40601 9.98596V10.7877ZM10.5331 10.7877C10.5331 10.9174 10.427 11.0235 10.2973 11.0235H8.62674C8.49711 11.0235 8.39094 10.9174 8.39094 10.7877V9.98596C8.39094 9.85628 8.49711 9.75016 8.62674 9.75016H10.2973C10.427 9.75016 10.5331 9.85628 10.5331 9.98596V10.7877Z"
          fill="#6C2AD2"
        />
        <path
          d="M15.1276 2.56323H12.3351C11.9285 2.56323 11.5977 2.89409 11.5977 3.30067V6.09325C11.5977 6.49989 11.9285 6.83074 12.3351 6.83074H13.4561V13.0984C13.4561 13.2504 13.5793 13.3736 13.7313 13.3736C13.8834 13.3736 14.0065 13.2504 14.0065 13.0984V6.8308H15.1276C15.5343 6.8308 15.8651 6.49995 15.8651 6.0933V3.30073C15.8651 2.89409 15.5343 2.56323 15.1276 2.56323ZM14.4951 4.87865C14.3345 5.02324 14.098 5.09656 13.792 5.09656H13.3877C13.3391 5.09656 13.2996 5.13613 13.2996 5.18468V5.86659C13.2996 5.94067 13.2393 6.00089 13.1652 6.00089H12.859C12.7848 6.00089 12.7246 5.94062 12.7246 5.86659V3.52761C12.7246 3.45347 12.7849 3.3932 12.859 3.3932H13.6304C14.1415 3.3932 14.3323 3.4702 14.489 3.60324C14.6544 3.74354 14.7381 3.95842 14.7381 4.24204C14.7381 4.51918 14.6564 4.73329 14.4951 4.87865Z"
          fill="#6C2AD2"
        />
        <path
          d="M14.0586 3.95803C13.984 3.90167 13.8519 3.87305 13.6662 3.87305H13.3888C13.3403 3.87305 13.3008 3.91257 13.3008 3.96106V4.52149C13.3008 4.56998 13.3403 4.6095 13.3888 4.6095H13.555C13.6161 4.6095 13.7147 4.60498 13.7749 4.59943C13.8333 4.59409 13.9981 4.5702 14.0586 4.52451C14.1312 4.46958 14.168 4.37458 14.168 4.24221C14.168 4.10857 14.1312 4.01296 14.0586 3.95803Z"
          fill="#6C2AD2"
        />
      </g>
      <defs>
        <clipPath id="clip0_12294_30034">
          <rect
            width="15"
            height="15"
            fill="white"
            transform="translate(0.863281 0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
const All = ({
  scrollToTopContainer,
  setPropertySelected,
  setPropertySeletedDetail,
  buyerId,
  index,
  proid,
  setProid,
  popover,
  proUniqueId,
  setProUniqueId,
  buyerpropertylist,
  handleExpandClose,
  handleChangePaAddressTwo,
  selectedPaBlue,
  setSelectedPaBlue,
  isPipelineManagement,
}) => {
  const [ownerexpandedcenterdata, setOwnerexpandedcenterdata] = useState([]);
  const [loader, setIsLoader] = useState(false);

  const fetchData = async () => {
    if (index == 0) {
      try {
        setIsLoader(true);
        const response = await getApiCall(
          OWNERCARD_EXPANDEDCENTER + `?ownerId=${buyerId}&filter=all`
        );
        setIsLoader(false);
        setOwnerexpandedcenterdata(response?.data);
      } catch (error) {}
    } else if (index == 1) {
      try {
        setIsLoader(true);
        const response = await getApiCall(
          OWNERCARD_EXPANDEDCENTER + `?ownerId=${buyerId}&filter=appraisals`
        );
        setIsLoader(false);
        setOwnerexpandedcenterdata(response?.data);
      } catch (error) {}
    } else if (index == 2) {
      try {
        setIsLoader(true);
        const response = await getApiCall(
          OWNERCARD_EXPANDEDCENTER + `?ownerId=${buyerId}&filter=inactive`
        );
        setIsLoader(false);
        setOwnerexpandedcenterdata(response?.data);
      } catch (error) {}
    }
  };

  useEffect(() => {
    fetchData();
  }, [buyerId.buyerId]);

  const numberWithCommas = (x) => {
    return x?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  };

  const [selectedBluePropertyId, setSelectedBluePropertyId] = useState(proid);

  const handleChange = (event, propertyId) => {
    if (popover) {
      handleExpandClose();
    }
    let values;
    if (buyerpropertylist && buyerpropertylist.length > 1) {
      buyerpropertylist?.map((item) => {
        if (item.pd_Id == event.target.value) {
          values = item?.propertyId;
        }
      });
    }
    const selectedPropertyId = propertyId;
    setProid(selectedPropertyId);
    setSelectedBluePropertyId(selectedPropertyId);
    setProUniqueId(values);
    handleChangePaAddressTwo(selectedPropertyId);
    setSelectedPaBlue('');
  };
  const theme = useTheme();
  const matchessm = useMediaQuery(theme.breakpoints.down('sm'));
  const matches420 = useMediaQuery(theme.breakpoints.down(420));
  const matches450 = useMediaQuery(theme.breakpoints.down(450));
  const matches870 = useMediaQuery(theme.breakpoints.down(870));
  const matches600 = useMediaQuery(theme.breakpoints.down(600));

  return (
    <>
      <Grid>
        {ownerexpandedcenterdata?.data == '' ? (
          <Grid
            sx={{
              textAlign: 'center',
              fontFamily: 'poppins',
              color: '#585858',
              alignItems: 'center',
              padding: '50px',
            }}
          >
            No data found
          </Grid>
        ) : (
          <Grid
            item
            xs={matchessm ? 'auto' : 10}
            display={'flex'}
            justifyContent={'flex-start'}
            flexDirection={'column'}
            alignItems={'center'}
            marginBottom={'80px'}
            ml={'10px'}
            // sx={{border:"1px solid red"}}
          >
            <div style={{ width: matchessm ? '100%' : 'auto' }}>
              {ownerexpandedcenterdata?.data?.map((item, index) => {
                const formattedSoldDate = moment(
                  item?.property?.soldDate
                ).format('DD-MM-YYYY');
                return (
                  <div
                    key={index}
                    style={{
                      width: matchessm ? '100%' : 'auto',
                      borderRadius: '8px',
                    }}
                  >
                    <Card
                      sx={{
                        minHeight: '138px',
                        border: '0',
                        padding: '0px',
                        boxShadow: '0px 1px 4px rgba(0, 0, 0, 0.15);',
                        marginTop: '10px',
                        borderRadius: '10px',
                        width: popover && matchessm ? '100%' : '350px',
                        marginLeft:
                          popover && matchessm
                            ? '0px'
                            : isPipelineManagement
                            ? '0px'
                            : '30px',
                        borderLeft:
                          (selectedPaBlue || selectedBluePropertyId) ==
                            item?.property?.propertyId && '8px solid #6C2AD2',
                      }}
                    >
                      <Stack direction={'row'}>
                        {/* {selectedBluePropertyId == item?.property?.propertyId && (
           <Box sx={{minHeight:'138px',width:'5px',background:'#6C2AD2',borderRadius:'8px 0 0 8px'}}></Box>)} */}
                        <Grid
                          container
                          direction={popover && matchessm ? 'row' : 'row'}
                          gap={popover && matchessm && '5px'}
                          onClick={(event) => {
                            handleChange(event, item?.property?.propertyId);
                            setPropertySelected((prev) => !prev);
                            setPropertySeletedDetail(item);
                            if (scrollToTopContainer.current) {
                              scrollToTopContainer.current.scrollTo({
                                top: 0,
                                left: 0,
                                behavior: 'smooth',
                              });
                            } else {
                              window.scrollTo({ top: 0, behavior: 'smooth' });
                            }
                          }}
                          sx={{
                            alignItems: 'center',
                            padding: '10px',
                            background: ' #FAF8F8',
                            borderRadius: '0px 8px 8px 0px',
                            flexWrap: 'nowrap',
                            display: popover && matches870 && 'flex',
                            justifyContent:
                              popover && matchessm && 'flex-start',
                            cursor: 'pointer',
                            marginLeft:
                              (selectedPaBlue || selectedBluePropertyId) !=
                                item?.property?.propertyId && '8px',
                          }}
                        >
                          <Grid
                            item
                            sx={{
                              width: popover ? '40vw' : '166px',
                              height: '173px',
                              display: 'flex',
                              flexDirection: 'column',
                            }}
                          >
                            <Box
                              sx={{
                                display: 'flex',
                                flexDirection: 'column',
                                height: '100%',
                              }}
                            >
                              {item?.propertyMedia?.find(
                                (media) =>
                                  media.mediaType === 'Image' &&
                                  media.propertyMedia
                              ) && (
                                <img
                                  src={
                                    item?.propertyMedia?.find(
                                      (media) => media.mediaType === 'Image'
                                    )?.propertyMedia
                                  }
                                  alt="Images"
                                  style={{
                                    width: '133px',
                                    height: '125px',
                                    objectFit: 'cover',
                                    borderRadius: '6px',
                                    flexShrink: 0,
                                  }}
                                  onError={(e) => {
                                    e.target.src = PlaceholderImage; // Fallback image if loading fails
                                  }}
                                />
                              )}
                              <Button
                                variant="text"
                                sx={{
                                  marginTop: 'auto',
                                  border: '1px solid #9A9A9F',
                                  fontFamily: 'Poppins !important',
                                  fontStyle: 'normal !important',
                                  fontWeight: '400 !important',
                                  borderRadius: '5px',
                                  fontSize: '12px',
                                  textTransform: 'capitalize',
                                  color: '#9A9A9F',
                                  width: '133px',
                                  height: '30px',
                                  flexShrink: 0,
                                }}
                              >
                                {item?.property?.isAppraisal == 0 &&
                                item?.property?.isPipeline == 1
                                  ? 'Not listed'
                                  : item?.property?.isAppraisal == 1 &&
                                    item?.property?.isPipeline == 1
                                  ? 'Appraisal'
                                  : item?.property?.status}
                              </Button>
                            </Box>
                          </Grid>

                          <Grid
                            item
                            sx={{
                              width: popover ? '40vw' : '166px',
                              display: 'flex',
                              flexDirection: 'column',
                            }}
                          >
                            <Stack
                              direction={'column'}
                              sx={{
                                height: '173px',
                                display: 'flex',
                                justifyContent: 'space-between',
                              }}
                            >
                              <Stack direction={'row'} spacing={2}>
                                <Stack
                                  direction={'row'}
                                  spacing={1}
                                  alignItems={'center'}
                                >
                                  <BedIcon />
                                  <Typography
                                    sx={{
                                      fontFamily: 'Poppins !important',
                                      fontStyle: 'normal !important',
                                      fontWeight: '400 !important',
                                      fontSize: '12px',
                                      color: '#000000',
                                    }}
                                  >
                                    {item?.propertyOtherDetails?.bedRoomCount}
                                  </Typography>
                                </Stack>
                                <Stack
                                  direction={'row'}
                                  spacing={1}
                                  alignItems={'center'}
                                >
                                  <ShowerIcon />
                                  <Typography
                                    sx={{
                                      fontFamily: 'Poppins !important',
                                      fontStyle: 'normal !important',
                                      fontWeight: '400 !important',
                                      fontSize: '12px',
                                      color: '#000000',
                                    }}
                                  >
                                    {item?.propertyOtherDetails?.bathRoomCount}
                                  </Typography>
                                </Stack>
                                <Stack
                                  direction={'row'}
                                  spacing={1}
                                  alignItems={'center'}
                                >
                                  <CarIcon />
                                  <Typography
                                    sx={{
                                      fontFamily: 'Poppins !important',
                                      fontStyle: 'normal !important',
                                      fontWeight: '400 !important',
                                      fontSize: '12px',
                                      color: '#000000',
                                    }}
                                  >
                                    {
                                      item?.propertyOtherDetails
                                        ?.otherCarParking
                                    }
                                  </Typography>
                                </Stack>
                              </Stack>
                              <Typography
                                sx={{
                                  fontFamily: 'Poppins !important',
                                  fontStyle: 'normal !important',
                                  fontWeight: '400 !important',
                                  fontSize: '10px',
                                  color: '#666666',
                                }}
                              >
                                {item?.propertyAddress?.streetName}
                              </Typography>
                              <Stack direction={'row'} spacing={'1'}>
                                <Stack direction={'row'} spacing={'1'}>
                                  <Typography
                                    sx={{
                                      fontFamily: 'Poppins !important',
                                      fontStyle: 'normal !important',
                                      fontWeight: '400 !important',
                                      fontSize: '10px',
                                      color: '#666666',
                                    }}
                                  >
                                    Last Sold: &nbsp;
                                  </Typography>
                                </Stack>
                                <Stack direction={'row'} spacing={'1'}>
                                  {item?.property?.soldDate != null && (
                                    <Typography
                                      sx={{
                                        fontFamily: 'Poppins !important',
                                        fontStyle: 'normal !important',
                                        fontWeight: '500 !important',
                                        fontSize: '10px',
                                        color: '#000000',
                                      }}
                                    >
                                      {formattedSoldDate}
                                    </Typography>
                                  )}
                                </Stack>
                              </Stack>
                              <Stack direction={'row'} spacing={'1'}>
                                <Stack>
                                  <Typography
                                    sx={{
                                      fontFamily: 'Poppins !important',
                                      fontStyle: 'normal !important',
                                      fontWeight: '400 !important',
                                      fontSize: '10px',
                                      color: '#666666',
                                    }}
                                  >
                                    Price: &nbsp;
                                  </Typography>
                                </Stack>
                                <Stack>
                                  {item?.property?.soldPrice != null && (
                                    <Typography
                                      sx={{
                                        fontFamily: 'Poppins !important',
                                        fontStyle: 'normal !important',
                                        fontWeight: '500 !important',
                                        fontSize: '10px',
                                        color: '#000000',
                                      }}
                                    >
                                      {`$${numberWithCommas(
                                        item?.property?.soldPrice
                                      )}`}
                                    </Typography>
                                  )}
                                </Stack>
                              </Stack>
                              <FormControl
                                sx={{
                                  // border: "1px solid #6C2AD2",
                                  background: '#FFFFFF',
                                  borderRadius: '5px',
                                  marginTop: 'auto',
                                  fontFamily: 'Poppins !important',
                                  fontStyle: 'normal !important',
                                  fontWeight: '500 !important',
                                  fontSize: '12px',
                                  width: popover ? '150px' : '100px',
                                  flexShrink: 0,
                                }}
                                size="small"
                              >
                                <Select
                                  sx={{
                                    ...poppins500,
                                    fontSize: '12px',
                                    color: '#6C2AD2',
                                    border: '1px solid #6C2AD2',
                                    borderRadius: ' 5px',
                                    height: '32px',
                                    width: popover ? '150px' : '100px',
                                    background: '#FFFFFF',
                                    boxShadow:
                                      '0px 1px 4px rgba(0, 0, 0, 0.15)',
                                    '& .MuiOutlinedInput-notchedOutline': {
                                      border: 'none',
                                    },
                                  }}
                                  size="small"
                                  value="10"
                                  style={{
                                    padding: '0px 2px',
                                  }}
                                  onChange={() => {}}
                                  displayEmpty
                                  inputProps={{ 'aria-label': 'Without label' }}
                                >
                                  <MenuItem value={10}>Action</MenuItem>
                                  <MenuItem value={20}>Twenty</MenuItem>
                                  <MenuItem value={30}>Thirty</MenuItem>
                                </Select>
                              </FormControl>
                            </Stack>
                          </Grid>
                        </Grid>
                      </Stack>
                    </Card>
                  </div>
                );
              })}
            </div>
          </Grid>
        )}
      </Grid>
      {loader && (
        <Grid sx={{ display: 'flex', justifyContent: 'center' }}>
          <img
            alt="Logo"
            src={Loading}
            className="loaderImage"
            style={{ height: '70px', width: '70px', marginTop: '15%' }}
          />
        </Grid>
      )}
    </>
  );
};

export default All;
